import React, { Component } from "react";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { aboutusbanner, aboutusreivew, aboutusreivew1, aboutusbanner1, aboutusWhatWeDo1, aboutusWhatWeDo, aboutusIcon1, aboutusIcon2, aboutusIcon3, aboutusPhilosophyimg, aboutuscaptionimg1, aboutuscaptionimg2, aboutuscaptionimg3, aboutuscaptionimg4 } from "shared/images/images";
import { aboutusUser, staricon } from "shared/assets/icons";
import { Helmet } from "react-helmet";
import { Breadcrumbs } from "shared/hoc/breadcrumbs/Breadcrumbs";
import { BREADCRUMB_TYPE_CONFIG } from "shared/hoc/breadcrumbs/config";

import './Aboutus.scss';

export const AboutusFn = (props) => {

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const backgroundImage = windowWidth < 600
    ? `linear-gradient(rgba(255,255,255,0.6), rgba(255,255,255,0.6)), url(${aboutusreivew})`
    : `linear-gradient(to right, rgba(255,255,255) 23%, rgba(255,255,255,0.90) 30%, rgba(255,255,255,0) 47%, rgba(255,255,255,0) 65%), url(${aboutusreivew1})`;

    const testimonalList  = [
      {
        stars: [staricon,staricon,staricon,staricon,staricon],
        text: `I love CTBids. It’s very easy to see what is up for auction, and easy to bid and watch. And picking up what I win is a fun adventure. Everyone involved is friendly, knowledgeable and helpful.`,
        name: 'Judith',
        location: 'Caring Transitions of S. Arizona'
      },
      {
        stars: [staricon,staricon,staricon,staricon,staricon],
        text: `Absolutely wonderful! Everyone on the team who was working the pickup was so kind and generous! One of, if not the best experience I’ve had with CTBids / “estate sales” in general.`,
        name: 'Izzy W',
        location: 'Caring Transitions of Parsippany'
      },
      {
        stars: [staricon,staricon,staricon,staricon,staricon],
        text: `I love the online auction of vintage items. I know these items come with history and love. This is a great company that does online estate sales.`,
        name: 'Can D',
        location: 'Caring Transitions of South Bay/PV'
      }
    ]

  return (
    <div>
      <Helmet>
        <title>CTBids | About Us</title>
      </Helmet>
      <div className="d-flex align-items-center clickable " style={{fontSize: "14px" }}>
      <Breadcrumbs props={props} type={BREADCRUMB_TYPE_CONFIG.ABOUT_US} />
      </div>
      <div className="w-100 d-flex justify-content-center aboutus-home" style={{ position: 'relative'}}>
        <img src={window.innerWidth > 600 ? aboutusbanner : aboutusbanner1}  onLoad={() => setImageLoaded(true)} alt="about-us-banner" style={{ width: '95%', borderRadius:'20px' }} />
        {imageLoaded && <div style={{  position: 'absolute', top: '5%',  left: '5%',  padding: '1rem',  borderRadius: '8px',}}>
          <h2 className="about-us-title">About Us</h2>
          <p className="about-us-sub-title">Our mission was founded on  {window.innerWidth > 500 && <br/>} respect, care, and connection.</p>
        </div>}
      </div>

      <div className="about-container">

        <section className="about-section what-we-do">
          <div className="text-content">
            <h2 className="section-title mt-3">What we do</h2>
            <p className="section-description">
              Born from a desire to serve families in times of change, CTBids is an extension of the values that drive Caring Transitions.
              Our roots are in senior relocation, downsizing, and estate sales—and we carry that same care, respect, and personal touch into
              every auction experience. We believe that every item has a story worth sharing, and every transition deserves to be honored.
              Through our platform, we help preserve cherished memories, support families in the present, and build a future that’s sustainable,
              connected, and filled with purpose and heart.
            </p>
          </div>
          <div className="image-container">
            <img src={windowWidth < 800 ? aboutusWhatWeDo1 : aboutusWhatWeDo} alt="What we do" className="what-we-do-image" />
          </div>
        </section>

        <section className="origins-section">
          <div className="origins-content">
            <h2 className="section-subtitle">From Caring Transitions Origins</h2>
            <p className="origins-section-description mb-4">
              For over 20 years, Caring Transitions has helped families navigate the emotional and logistical challenges of downsizing,
              relocating, and estate liquidation. What started as a heartfelt mission to bring dignity and compassion to these moments
              has grown into a nationwide network of trusted, expert support.    </p>
            <div className="cards-scroll-wrapper">
              <div className="cards-row">
                <div className="origin-card">
                  <div className="card-placeholder">
                    <img src={aboutuscaptionimg1} alt="From Caring Transitions Origins" className="origin-image" />
                  </div>
                  <p className="card-caption">Every story matters.</p>
                </div>
                <div className="origin-card">
                  <div className="card-placeholder">
                    <img src={aboutuscaptionimg2} alt="From Caring Transitions Origins2" className="origin-image" />
                  </div>
                  <p className="card-caption">Every moment deserves care.</p>
                </div>
                <div className="origin-card">
                  <div className="card-placeholder">
                    <img src={aboutuscaptionimg3} alt="From Caring Transitions Origins3" className="origin-image" />
                  </div>
                  <p className="card-caption">Nationwide care, local support.</p>
                </div>
                <div className="origin-card">
                  <div className="card-placeholder">
                    <img src={aboutuscaptionimg4} alt="From Caring Transitions Origins4" className="origin-image" />
                  </div>
                  <p className="card-caption">Guidance you can trust.</p>
                </div>
              </div>
            </div>

          </div>
        </section>

        <section className="philosophy-section">
          <div className="philosophy-container">
            <div className="philosophy-left">
              <h2 className="philosophy-title">Our Philosophy</h2>
              <p className="philosophy-text mb-4">
                We believe that every transition deserves to be met with compassion, integrity, and thoughtful support.
                Whether someone is downsizing, relocating, or settling an estate, we honor the emotional weight of each
                decision and treat every item as a meaningful part of the journey.
              </p>
              <p className="philosophy-text">
                We approach every auction with purpose—curating each listing with care and ensuring buyers and sellers feel
                secure, respected, and supported. Our philosophy is simple: preserve the past, serve the present, and create
                opportunities for the future.
              </p>
            </div>
            <div className="philosophy-right">
              <img
                src={aboutusPhilosophyimg}
                alt="Our Philosophy"
                className="philosophy-main-img"
              />
              <div className="philosophy-sub-imgs">
                <img
                  src="https://imageuat.ctbids.com/buyer/b7952d2f271556931745892b35514f174b6b1a25.jpg"
                  alt="Our Philosophy1"
                />
                <img
                  src="https://imageuat.ctbids.com/buyer/204e541f2803e22fb61a3062e1cd8e246b0e17d3.jpg"
                  alt="Our Philosophy2"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="about-section care-we-take">
          <h2 className="care-we-take-section-title mt-3 center">The Care We Take</h2>
          <div className="care-cards text-center">
            <div className="care-card curated text-center">
              <div className="w-50 mx-auto mb-4 text-center">
                <img src={aboutusIcon1} alt="Man viewing photos on wall" className="what-we-do-image w-100" />
              </div>
              <h3>Curated and Trusted Auctions</h3>
              <p>Every listing includes clear details and quality photos so you can bid with confidence.</p>
            </div>
            <div className="care-card seamless text-center">
              <div className="w-50 mx-auto mb-4">
                <img src={aboutusIcon2} alt="Man viewing photos on wall1" className="what-we-do-image w-100" />
              </div>
              <h3>Seamless Bidding Experience</h3>
              <p>Bid anytime, anywhere! Our platform works great on desktop and mobile.</p>
            </div>
            <div className="care-card winning text-center">
              <div className="w-50 mx-auto mb-4">
                <img src={aboutusIcon3} alt="Man viewing photos on wall2" className="what-we-do-image w-100" />
              </div>
              <h3>Winning & Item Pickup</h3>
              <p>After winning, we’ll help schedule local pickup or shipping if available</p>
            </div>
          </div>

        </section>

      </div>
      <div className="about-sections">
        <div
          className="about-hero"
          style={{ backgroundImage: backgroundImage }}>
          <div className="about-text">
            <h2>Where Purpose Meets <br/> Possibility</h2>
            <p>
              We don’t just help you sell things. We help you celebrate the life behind them and what’s next.
            </p>
            <div className="learn-more-section">
              {/* <button className="learn-more">Learn more</button> */}
            </div>
          </div>
        </div>

        <div className="testimonial-section">
          {testimonalList.map((review, i) => (
            <div key={i} className="testimonial-card">
              <p className="stars">{review.stars}</p>
              <p className="testimonial-text">{review.text}</p>
              <div className="testimonial-author">
                <div className="author-img">
                  {aboutusUser}
                </div>
                <div className="author-info">
                  <p className="author-name">{review.name}</p>
                  <p className="author-location">{review.location}</p>
                </div>
              </div>
            </div>

          ))}
        </div>
      </div>


    </div>
  );
};

class AboutUs extends Component {
  constructor(props) {
    super(props);
  }


  render() {
    return <AboutusFn {...this.props} />
  }
}

export default connect(state => state)(AboutUs);
